import { GROUP_QUOTE_MAX, LIVE_VERDICTS, quoteLength } from "@proef/domain";
import { z } from "zod";
import { PublicUser } from "./friendship.js";

/** What a taster chose to say to the group about one wine: plain text, counted in characters. */
export const GroupQuote = z.string().refine((text) => quoteLength(text) <= GROUP_QUOTE_MAX, {
  error: `at most ${String(GROUP_QUOTE_MAX)} characters`,
});
export type GroupQuote = z.infer<typeof GroupQuote>;

/** A faulty bottle is a verdict too, so the whole quality scale is allowed here. */
const Verdict = z.enum(["faulty", ...LIVE_VERDICTS]);

export const SessionVerdict = z.object({
  userId: z.string().min(1),
  quality: Verdict,
  quote: GroupQuote.min(1).exactOptional(),
});
export type SessionVerdict = z.infer<typeof SessionVerdict>;

/** One wine's verdicts: only wines the viewer may see them for are listed. */
export const SessionVerdictWine = z.object({
  index: z.int().nonnegative(),
  verdicts: z.array(SessionVerdict),
});
export type SessionVerdictWine = z.infer<typeof SessionVerdictWine>;

/**
 * GET /v1/sessions/:id/verdicts -- what each person in a shared tasting thought of each wine, for
 * the people taking part. A wine is listed once the viewer has handed in their own note on it, or,
 * in a blind tasting, once the host has shown it; never before, and never for a person a block
 * stands between. Empty for a session with no flight.
 */
export const SessionVerdicts = z.object({
  blind: z.boolean(),
  /** Everyone the rows are about, so a screen can name them. */
  people: z.array(z.object({ userId: z.string().min(1), profile: PublicUser })),
  wines: z.array(SessionVerdictWine),
});
export type SessionVerdicts = z.infer<typeof SessionVerdicts>;
